module.exports = __webpack_public_path__ + "static/media/Duvall_Mine.71388910.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/itbuildout/Duvall_Mine.jpg
// module id = 402
// module chunks = 0